import { getLocalizedValue } from '../../constants/Languages';
import { formatCurrency } from '../../utils/currencyUtils';
import { formatCalendarDate } from '../../utils/dateFormatUtils';

export const getServicePackageName = (name, language, t) => (
  getLocalizedValue(name, language, undefined, t('servicePackagesManagement.card.unnamed'))
);

export const getCustomerServicePackageDisplay = (customerPackage, language, t) => ({
  customerName: customerPackage.customerName || t('servicePackagesManagement.customerPackages.table.unnamedCustomer'),
  packageName: getServicePackageName(customerPackage.name, language, t),
  usesLabel: t('servicePackagesManagement.customer.remaining', {
    remaining: Math.max(0, customerPackage.remainingQuantity || 0),
    total: customerPackage.quantity || 0,
  }),
  channelLabel: customerPackage.paymentChannel
    ? t(`servicePackagesManagement.customer.channel.${customerPackage.paymentChannel}`, {
      defaultValue: customerPackage.paymentChannel,
    })
    : '',
  purchasedLabel: formatCalendarDate(customerPackage.purchaseDate),
  expiresLabel: customerPackage.expiresOn
    ? formatCalendarDate(customerPackage.expiresOn)
    : t('servicePackagesManagement.customer.noExpiry'),
  priceLabel: formatCurrency(customerPackage.pricePaid, customerPackage.currency),
});

export const getServicePackageExpiryLabel = (expiresInMonths, t) => {
  const months = Number.parseInt(expiresInMonths, 10);
  return Number.isInteger(months) && months > 0
    ? t('servicePackagesManagement.card.expiresAfter', { count: months })
    : t('servicePackagesManagement.card.noExpiry');
};

export const getServicePackageServiceNames = (serviceIds, services, language, t) => {
  const servicesById = new Map((services || []).map((service) => [service.id, service]));
  return (serviceIds || []).map((serviceId) => {
    const service = servicesById.get(serviceId);
    return service
      ? getLocalizedValue(service.name, language, undefined, t('servicePackagesManagement.card.removedService'))
      : t('servicePackagesManagement.card.removedService');
  });
};

export const getServicePackageProfessionalNames = (teamMemberIds, teamMembers) => {
  const membersById = new Map((teamMembers || []).map((member) => [String(member.id), member]));
  return (teamMemberIds || [])
    .map((teamMemberId) => membersById.get(String(teamMemberId))?.name)
    .filter(Boolean);
};
